import { render, staticRenderFns } from "./loginSideBar.vue?vue&type=template&id=82f872f0&scoped=true&"
import script from "./loginSideBar.vue?vue&type=script&lang=js&"
export * from "./loginSideBar.vue?vue&type=script&lang=js&"
import style0 from "./loginSideBar.vue?vue&type=style&index=0&id=82f872f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f872f0",
  null
  
)

export default component.exports